import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router/lib/Link';
import MediaQuery from '../common/media_query';
import OpenerImage from '../common/opener_image';
import OpenerImagesPropTypes from '../../utils/prop-types/OpenerImagesPropTypes';
import { sendAnalyticsEvent, sendDataLayerEvent } from '../../utils/analytics';

class RelatedEntriesLink extends Component {
  handleClick = () => {
    sendAnalyticsEvent(
      'Related Links',
      'Click',
      `${this.props.cellIndex}::${this.props.url}`
    );
    sendDataLayerEvent('Click', {
      itemIndex: this.props.cellIndex,
      itemName: this.props.title,
      linkTitle: this.props.title,
      linkType: 'article',
      linkUID: this.props.id,
      linkURL: this.props.url,
      pageModule: 'Related Stories (In-line)'
    });
  };

  render = () => (
    <Link to={this.props.url} onClick={this.handleClick}>
      {this.props.shouldShowImages &&
        <MediaQuery breakpoint="desktop">
          <OpenerImage
            rowType="related-entries"
            opener_images={this.props.opener_images}
          />
        </MediaQuery>
      }
      <div className="related-entry-content">
        <span
          className="related-entry-title"
          dangerouslySetInnerHTML={{ __html: this.props.title }}
        />
      </div>
    </Link>
  );
}

RelatedEntriesLink.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  cellIndex: PropTypes.number.isRequired,
  opener_images: OpenerImagesPropTypes.isRequired,
  shouldShowImages: PropTypes.bool,
  id: PropTypes.number.isRequired
};

export default RelatedEntriesLink;
